import React from 'react';
import queryString from 'query-string';
import { Card, Col, Row } from 'react-bootstrap';
import { Form, Button } from 'react-bootstrap';

import PageBar from '../../component/PageBar';
// import {listNotice} from '../../lib/Notice';
import moment from 'moment';

class List extends React.Component {
    constructor(props) {
        super(props);

        const query = queryString.parse(window.location.search);
        const page = query.page ? query.page : 1;

        this.state = {
            items: [],
            search: {
                searchKeyword: '',
                pageNumber: 1,
                size: 20,
            },
            totalPages: 20,
        };
    }

    reloadList = page => {
        const params = this.state.search;
        params.pageNumber = page;
        // sessionStorage.setItem('notice_list', JSON.stringify(params));
        // sessionStorage.setItem('notice_list_important', JSON.stringify(this.state.important));

        this.setState({
            search: params,
        });

        // listNotice(this, params, this.resultList.bind(this));
    };

    /**
     * 등록
     * @param {*} e
     */
    clickAdd = e => {
        // this.props.history.push('/a/board/edit');
        // window.history.pushState({ type: 11 }, undefined, '/a/board/edit');
        window.location = '/a/driver/edit';
    };

    /**
     * 셀 클릭
     */
    clickRow = id => {
        // this.props.history.push('/notice/info/' + id);
        window.location = '/a/driver/edit/' + id;
    };

    render() {
        return (
            <div>
                <Row
                    onClick={e => {
                        // if (this.state.showStatus) {
                        //     this.setState({ showStatus: false });
                        // }
                        // if (this.state.showImportant) {
                        //     this.setState({ showImportant: false });
                        // }
                    }}
                >
                    <Col>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">기사 할당</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="board_top_box">
                                    <div className="lb">
                                        <Row>
                                            <Col>
                                                <Form.Control as="select" onChange={this.onChange}>
                                                    <option value={''}>지사전체</option>
                                                    <option value={'1'}>서울지사</option>
                                                    <option value={'2'}>광주지사</option>
                                                </Form.Control>
                                            </Col>
                                            <Col>
                                                <Form.Control as="select" onChange={this.onChange}>
                                                    <option value={''}>구분전체</option>
                                                    <option value={'1'}>지입</option>
                                                    <option value={'2'}>계약</option>
                                                </Form.Control>
                                            </Col>
                                            <Col>
                                                <input
                                                    placeholder="검색어를 입력하세요."
                                                    type="text"
                                                    class="form-control search01"
                                                    onChange={e => {
                                                        const search = this.state.search;
                                                        search.searchKeyword = e.target.value;
                                                        this.setState({ search });
                                                    }}
                                                    onKeyPress={e => {
                                                        if (e.key === 'Enter') {
                                                            this.reloadList(1);
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col>
                                                <Button variant="success" onClick={e => this.reloadList(1)} style={{ width: '100%' }}>
                                                    검색
                                                </Button>
                                                {/* <button type="button" className="btn_search_1">
                                                    <i className="feather icon-search" onClick={e => this.reloadList(1)} />
                                                </button> */}
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="rb"></div>
                                </div>

                                <div className="table_board_box">
                                    <table className="tbl_board">
                                        <colgroup>
                                            <col width="100" />
                                            <col width="200" />
                                            <col width="150" />
                                            <col width="150" />
                                            <col width="150" />
                                            <col width="100" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="200" />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>지사</th>
                                                <th>이름</th>
                                                <th>연락처</th>
                                                <th>차량번호</th>
                                                <th>차량톤수</th>
                                                <th>기사타입</th>
                                                <th>금일 할당량/완료</th>
                                                <th>이번달 할당량/완료</th>
                                                <th>누적 할당량/완료</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1</td>
                                                <td>서울지사</td>
                                                <td>홍길동</td>
                                                <td>010-123-1234</td>
                                                <td>전남44바1234</td>
                                                <td>1톤</td>
                                                <td>지입</td>
                                                <td>1/1 </td>
                                                <td>5/4</td>
                                                <td>100/88</td>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>서울지사</td>
                                                <td>홍길동</td>
                                                <td>010-123-1234</td>
                                                <td>전남44바1234</td>
                                                <td>1톤</td>
                                                <td>지입</td>
                                                <td>1/1 </td>
                                                <td>5/4</td>
                                                <td>100/88</td>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>서울지사</td>
                                                <td>홍길동</td>
                                                <td>010-123-1234</td>
                                                <td>전남44바1234</td>
                                                <td>1톤</td>
                                                <td>지입</td>
                                                <td>1/1 </td>
                                                <td>5/4</td>
                                                <td>100/88</td>
                                            </tr>
                                            <tr>
                                                <td>1</td>
                                                <td>서울지사</td>
                                                <td>홍길동</td>
                                                <td>010-123-1234</td>
                                                <td>전남44바1234</td>
                                                <td>1톤</td>
                                                <td>지입</td>
                                                <td>1/1 </td>
                                                <td>5/4</td>
                                                <td>100/88</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <div className="gab40"></div>

                                <div className="textRight">
                                    <PageBar nowPage={Number(this.state.search.pageNumber)} totalPage={this.state.totalPages} reload={this.reloadList} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default List;
